
import { defineComponent } from 'vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'schedulation-agenda-management-hint',
    components: { KnHint }
})
